import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises
import { MatTableModule } from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
// Autres modules externes utilises 

// Modules metiers utilises
import { AntenneModule } from '../../structure/antenne/antenne.module';
import { ParcModule } from '../../structure/parc/parc.module';
import { SousParcModule } from '../../structure/sous-parc/sous-parc.module';
import { OuvrageModule } from '../../structure/ouvrage/ouvrage.module';
import { UserModule } from '../user/user.module';
import { EventsModule } from '../../../technical-modules/events/event-bus.module';

// Modules communs utilises
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';
import { JSR310LocalDatesModule } from '../../../shared/jsr310-localdates/jsr310-localdates.module';
import { PannelModule }  from '../../../shared/pannel/pannel.module';

// Composants metiers
import { ResponsabiliteWidgetComponent } from './components/responsabilite-widget.component';
import { TransfertsCacEnCoursComponent } from './components/transferts-cac-en-cours.component';
import { TransfertConfiguratorComponent } from './components/transfert-configurator.component';

// Services metier
import { PerimetreResponsabiliteService } from './services/perimetre-responsabilite.service';
import { TransfertResponsabiliteService } from './services/transfert-responsabilite.service';

// Bridges avec la partie anguler
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';
import { ConsultationPerimetreComponent } from './components/consultation-perimetre.component';
import { ConsultationPerimetreFiltersComponent } from './components/consultation-perimetre-filters.component';
import { ResponsabiliteGridComponent } from './components/responsabilite-grid.component';
import { HistoriqueTransfertsComponent } from './components/historique-transferts-component';
import { TransfertResponsabiliteComponent } from './components/transfert-responsabilite.component';


@NgModule({
	imports: [
		BrowserModule,
		FormsModule,

		MatTableModule,
		MatTabsModule,
		MatPaginatorModule,
		MatSortModule,
		
		CheckboxListModule,
		FilterableSelectModule,
		JSR310LocalDatesModule,
		PannelModule,

		AntenneModule,
		ParcModule,
		SousParcModule,
		OuvrageModule,
		UserModule,
		EventsModule
	],
	providers: [
		PerimetreResponsabiliteService,
		TransfertResponsabiliteService,
	],
	declarations: [
		ResponsabiliteGridComponent,
		HistoriqueTransfertsComponent,
		ResponsabiliteWidgetComponent,
		TransfertsCacEnCoursComponent,
		ConsultationPerimetreComponent,
		ConsultationPerimetreFiltersComponent,
		TransfertResponsabiliteComponent,
		TransfertConfiguratorComponent,
	],
	exports: [
		ResponsabiliteGridComponent,
		HistoriqueTransfertsComponent,
		ResponsabiliteWidgetComponent,
		TransfertsCacEnCoursComponent,
		ConsultationPerimetreComponent,
		ConsultationPerimetreFiltersComponent,
		TransfertResponsabiliteComponent,
		TransfertConfiguratorComponent,
	]
})
export class ResponsablesModule {
	constructor() { }
}

// Initialisation des directives pour usage dans les templates angular-js
angular.module('auroraApp') //
 	.directive('responsabiliteWidget',
		downgradeComponent({ component: ResponsabiliteWidgetComponent })
	) //
 	.directive('transfertsCacEnCours',
		downgradeComponent({ component: TransfertsCacEnCoursComponent })
	) //
 	.directive('transfertConfigurator',
		downgradeComponent({ component: TransfertConfiguratorComponent })
	) //
;